import { Injectable } from '@angular/core';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFireDatabase } from 'angularfire2/database';
import * as firebase from 'firebase/app';
import { Router } from '@angular/router';
import { AngularFirestore } from 'angularfire2/firestore';
const identifier = "token";

@Injectable({
    providedIn: 'root'
})
export class AuthService {

    constructor(
        public database: AngularFireDatabase,
        private angularAuth: AngularFireAuth,
        private router: Router,
        public db: AngularFirestore
    ) {
        this.setUp();
    }
    token: string = this.getTokenFromLocalStorage();

    setUp() {
        this.token = this.getTokenFromLocalStorage();
        this.angularAuth.authState.subscribe((firebaseUser) => {
            if (firebaseUser) {
                localStorage.setItem(identifier, firebaseUser.uid);
                this.token = firebaseUser.uid;
            } else {
                localStorage.removeItem(identifier)
                this.token = null;
            }
        })
    }

    getTokenFromLocalStorage(): string {
        return localStorage.getItem(identifier)
    }

    login(data) {
        return new Promise((resolve, reject) => {
            this.angularAuth.auth.signInWithEmailAndPassword(data.email, data.password).then((data) => {
                resolve(data);
            }, (err) => {
                reject(err);
            })
        });
    }

    logOut() {
        return this.angularAuth.auth.signOut().then(() => {
            this.token = null;
        });
    }

    resetPassword(emailAddress) {
        let auth = firebase.auth();
        return new Promise((resolve, reject) => {
            auth.sendPasswordResetEmail(emailAddress).then(function () {
                resolve(true);
            }).catch(function (error) {
                reject(error);
            });
        });
    }

    getCurrentUser() {
        return firebase.auth().currentUser;
    }

    signUp(data) {
        let self = this;

        return new Promise((resolve, reject) => {
            firebase.auth().createUserWithEmailAndPassword(data.email, data.password).then(function (user_db) {

                user_db.user.updateProfile({
                    displayName: data.fullname,
                    photoURL: ''
                }).then(function () {

                    let account_key = user_db.user.uid;

                    self.db.collection("accounts").doc(account_key).set({
                        username: data.username,
                        fullname: data.fullname,
                        email: data.email,
                        phone: data.phone,
                        balance: 0,
                        created_at: new Date(),
                    }).then(function () {
                        resolve(true);
                    }).catch(function (error) {
                        console.error("Error writing document: ", error);
                        reject(error);
                    });

                }, function (error) {
                    reject(error);
                });
            }, function (error) {
                reject(error);
            });
        });

    }

}
